import { Navigate, Outlet } from 'react-router';

import { useCurrentUser } from '@app-velocity/libs/auth';
import { useCurrentTeamPermissions } from '@app-velocity/libs/team-permissions';

export const AppraisalLimitProtectedRoute = () => {
  const currentUser = useCurrentUser();
  const currentTeam = useCurrentTeamPermissions();

  if (!currentUser || !currentTeam || !currentTeam.canRunAppraisals())
    return <Navigate to="/" />;

  return <Outlet />;
};
